var map = {
	"./Afternoon.mp3": "8321",
	"./Ball.mp3": "12d1",
	"./Banana.mp3": "4b4a",
	"./Bed.mp3": "7a40",
	"./Boots.mp3": "5bfa",
	"./Camel.mp3": "cda1",
	"./Crocodile.mp3": "a426",
	"./Dress.mp3": "e3f0",
	"./Elephant.mp3": "a89f",
	"./Evening.mp3": "c75a",
	"./Giraffe.mp3": "facd",
	"./House.mp3": "7222",
	"./Lion.mp3": "a2a0",
	"./Monkey.mp3": "6ca3",
	"./Morning.mp3": "d90a",
	"./Polarbear.mp3": "0cbd",
	"./Pyjamas.mp3": "4539",
	"./Shorts.mp3": "681f",
	"./Strawberries.mp3": "8a57",
	"./Swingsuit.mp3": "bb37",
	"./Thankyou.mp3": "d314",
	"./Tiger.mp3": "83c0",
	"./Toilet.mp3": "b696",
	"./Trousers.mp3": "7283",
	"./Zebra.mp3": "3864",
	"./ambulance.mp3": "5004",
	"./bathroom.mp3": "22f0",
	"./bedroom.mp3": "806f",
	"./bell.mp3": "d719",
	"./bell.wav": "9231",
	"./bullet.mp3": "1b5a",
	"./cat.mp3": "c7ee",
	"./cheetah.mp3": "d59a",
	"./coat.mp3": "dd82",
	"./cow.mp3": "1ef0",
	"./dog.mp3": "36b7",
	"./explosion.mp3": "6a46",
	"./family.mp3": "debe",
	"./father.mp3": "6131",
	"./fizzle.mp3": "69c8",
	"./grandfather.mp3": "551a",
	"./grandmother.mp3": "1a51",
	"./jacket.mp3": "a3d3",
	"./kitchen.mp3": "00b0",
	"./livingroom.mp3": "1f15",
	"./mother.mp3": "062f",
	"./mouse.mp3": "a76e",
	"./movie.mp3": "fc15",
	"./parrot.mp3": "8a8b",
	"./punch.mp3": "b6f9",
	"./shoes.mp3": "6ead",
	"./skirt.mp3": "7c81",
	"./snake.mp3": "6115",
	"./telephone.mp3": "2c5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";